import { Title } from "@mantine/core";
import { L2KH2Props } from "./types";
import { H2_STYLE, COLORS } from "./constants";

/**
 * L2KH2 - Second level heading component
 * Renders as <h2> by default, uses Big Shoulders Display font
 * Responsive sizing: 36px → 48px across 320px → 1920px viewports
 */
export function L2KH2({
  children,
  variant = "primary",
  component = "h2",
  style,
  ...props
}: L2KH2Props) {
  return (
    <Title
      order={2}
      component={component}
      style={{
        fontSize: H2_STYLE.fontSize,
        lineHeight: H2_STYLE.lineHeight,
        letterSpacing: H2_STYLE.letterSpacing,
        fontWeight: H2_STYLE.fontWeight,
        fontFamily: H2_STYLE.fontFamily,
        margin: 0,
        color: COLORS[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
}
